import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { SESSION_LOCALE } from 'utils/constants'

// locales
import ptBR from './locales/pt-BR'
import en from './locales/en'

Vue.use(VueI18n)

const currentLocale = localStorage.getItem(SESSION_LOCALE) || 'pt_BR'
const messages = { pt_BR: ptBR, en }

Object.keys(messages).forEach(key => {
  const locale = messages[key]
  const localeTextReplace = JSON.stringify(locale)
    // break line
    .replace(/\[br\]/g, '<br>')

    // font weight
    .replace(/\[tb\](.+?)\[\/tb\]/g, '<strong class=\'text--bold\'>$1</strong>')
    .replace(/\[tsb\](.+?)\[\/tsb\]/g, '<strong class=\'text--semibold\'>$1</strong>')
    .replace(/\[ti\](.+?)\[\/ti\]/g, '<em>$1</em>')

    // text color
    .replace(/\[tac\](.+?)\[\/tac\]/g, '<span class=\'accent--text\'>$1</span>')
    .replace(/\[tw\](.+?)\[\/tw\]/g, '<span class=\'white--text\'>$1</span>')

  const localeObject = JSON.parse(localeTextReplace)
  messages[key] = localeObject
})

const i18n = new VueI18n({
  locale: currentLocale,
  fallbackLocale: ptBR,
  messages
})

export default i18n
